'use client'

import { usePathname, useRouter } from 'next/navigation'

import { AgreementContentRenderer, GroupMenu, Hero } from '@/components'
import privacyPolicy from '@/libs/constants/privacy-policy'

export default function PrivacyPolicy() {
  const { push } = useRouter()
  const pathname = usePathname()
  const listGroupMenu = [
    {
      name: 'terms-and-condition',
      title: 'Terms',
    },
    {
      name: 'privacy-policy',
      title: 'Privacy',
    },
  ]

  return (
    <>
      <Hero pathname={pathname} />
      <GroupMenu
        listMenu={listGroupMenu}
        selectedMenu='privacy-policy'
        onClick={(e) => push(`/articles/${e}`)}
      />
      <main className='relative flex flex-row'>
        <div className='mx-auto w-full md:flex-grow'>
          <div className='mx-auto flex flex-col gap-4 px-5 py-4 md:px-12 md:py-6 lg:w-3/4 lg:py-9 xl:w-1/2 xl:py-12'>
            <h1 className='text-sm font-bold'>Last updated on March 2025</h1>
            <AgreementContentRenderer content={privacyPolicy} />
          </div>
        </div>
      </main>
    </>
  )
}
